"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const temaPadrao_1 = __importDefault(require("../../../components/CeMuiThemeProvider/temaPadrao"));
const QontoStepIcon_1 = require("../QontoStepIcon");
const styles_1 = require("./styles");
const StepConnectorStyled = core_1.withStyles((theme = temaPadrao_1.default) => ({
    alternativeLabel: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    active: {
        '& $line': {
            borderColor: theme.palette.secondary.main,
        },
    },
    completed: {
        '& $line': {
            borderColor: theme.palette.secondary.main,
        },
    },
    line: {
        borderColor: theme.palette.grey.A100,
        borderTopWidth: 3,
        borderRadius: 1,
    },
}))(core_1.StepConnector);
const RenderStepper = ({ activeStep, steps, lazyLabels, }) => {
    return (react_1.default.createElement(styles_1.StepperStyled, { activeStep: activeStep, alternativeLabel: true, connector: react_1.default.createElement(StepConnectorStyled, null) }, steps.map((step, idx) => {
        const label = lazyLabels.length > 0 ? lazyLabels[idx] : step.label;
        return (react_1.default.createElement(core_1.Step, Object.assign({ key: label }, {}),
            react_1.default.createElement(core_1.StepLabel, Object.assign({}, {}, { StepIconComponent: QontoStepIcon_1.QontoStepIcon }),
                react_1.default.createElement(core_1.Hidden, { smDown: true },
                    react_1.default.createElement(styles_1.LabelStyled, { activeStep: activeStep, step: idx }, label)))));
    })));
};
exports.default = RenderStepper;
//# sourceMappingURL=index.js.map